/*
 * @Author: Zhanglei
 * @Date: 2020-07-06 14:16:23
 * @LastEditTime: 2020-08-21 21:03:27
 * @LastEditors: Zhanglei
 * @Description: In User Settings Edit
 * @FilePath: /desktop/src/languages/zh-CN.js
 */
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
const cn = {
  network: {
    permission: "身份验证会话已过期。请再次登录。",
    noNetWork: "网络异常，请检查您的网络",
    nowork: "当前访问人数过多，请稍后重试",
    error: "当前系统异常，请退出重试"
  },
  header: {
    lang: "切换语言",
    logout: "退出登录",
    name: "宝马(中国)工会"
  },
  button: {
    operation: "操作",
    details: "详情",
    orderDetails: "订单详情",
    delete: "删除",
    redact: "编辑",
    cancel: "取消",
    confirmDelete: "确认删除",
    confirmDeleteData: "确认删除",
    confirmUpdate: "批量导出",
    confirmUpdateData: "确认导出",
    confirm: "确定",
    Reservation: "预订情况",
    pickCar: "取车",
    returnCar: "还车",
    AdditionalFee: "收费",
    RefundFee: "退款",
    ModifyPrice: "改价",
    changeCar: "换车",
    Approve: "审批",
    pass: "通过",
    submit: "提交",
    return: "返回",
    Refuse: "拒绝",
    Import: "批量导入",
    download: "全部下载",
    returnL: "返回上一页"
  },
  list: {
    delete: "删除",
    tips: '提示',
    determine: '确定',
    cancel: '取消',
    deletionCancelled: '已取消删除!',
    batchDeletion: '批量删除',
    confirmDelete: "确认删除",
    pleaseSelectTheDataToDelete: '请选择要删除的数据'
  },
  login: {
    sysname: "系统名称",
    passwordlogin: "账户密码登录",
    account: "账户",
    password: "密码",
    enter: "登录",
    verificationcode: "验证码",
    forgetpassword: "忘记密码",
    registeraccount: "注册账户",
    help: "帮助",
    privacy: "隐私",
    terms: "条款",
    scanningcode: "二维码登录",
    openjoychat: "打开JoyChat",
    scanningcodelogin: "扫码后点击“确认授权”，即可完成账号登录",
    prompt_code: "请输入验证码!",
    prompt_account: "请填写账户！",
    prompt_pass: "请填写密码！",
    error_pass: "账号或密码错误！",
    error_login: "登录失败!",
    // eslint-disable-next-line no-dupe-keys
    help: "帮助",
    // eslint-disable-next-line no-dupe-keys
    privacy: "隐私",
    // eslint-disable-next-line no-dupe-keys
    terms: "条款"
  },
  table: {
    conditionsQuery: "条件查询",
    dataSort: "数据排序",
    configurationColumn: "配置列显示",
    newData: "新建",
    deleteData: "删除",
    confirmDeleteData: "确认删除",
    deriveData: "导出",
    refreshData: "刷新",
    more: "更多",
    queryData: "查询",
    resetAll: "全部重置",
    packUp: "收起",
    account: "账号",
    id: "ID",
    authType: "认证类型",
    creator: "创建者",
    createdAt: "创建时间",
    updatedAt: "更新时间",
    lastLoginTime: "最后登录时间",
    isForbidden: "是否禁用",
    AddToGroup: "添加到组",
    AddToUnit: "添加到单元",
    AddToRole: "添加到角色",
    start: "开始",
    end: "结束",
    user: {
      name: "关联用户"
    },
    isEnabled: "是否启用"
  },
  user: {
    id: "ID",
    name: "名字",
    jobNumber: "工号",
    gender: "性别",
    department: "部门",
    idType: "证件类型",
    idNumber: "证件号码",
    mobile: "手机号",
    telephone: "固定电话",
    email: "电子邮件",
    dimission: "是否离职",
    address: "工作地址",
    createdAt: "创建时间",
    syncedAt: "同步时间",
    updatedAt: "更新时间",
    displayName: "显示名",
    firstName: "名",
    lastName: "姓",
    birthName: "出生名",
    title: "岗位",
    leader: "是否领导",
    departmentCode: "部门编码"
  },
  dialog: {
    createTitle: "新建",
    editTitle: "编辑",
    deleteTitle: "删除",
    infoTitle: "详情",
    returnCar: "还车",
    pickCar: "取车",
    AdditionalTitle: "追加费用",
    returnTitle: "退还费用",
    ModifyPrice: "修改价格"
  },
  template: {
    id: "ID",
    name: "名称",
    version: "版本",
    route: "路由",
    createdAt: "创建时间",
    operating: "操作",
    createTitle: "新建",
    grid: "模板",
    enter: "请输入"
  },
  group: {
    id: "ID",
    name: "名称",
    code: "组编码",
    createdAt: "创建时间",
    syncedAt: "同步时间",
    updatedAt: "更新时间",
    type: "组类型"
  },
  carGroup: {
    id: "ID",
    name: "名称",
    region: "区域",
    fleets: "车队",
    createdAt: "创建时间",
    syncedAt: "同步时间",
    updatedAt: "更新时间"
  },
  endpoint: {
    id: "ID",
    name: "名称",
    createdAt: "创建时间",
    syncedAt: "同步时间",
    updatedAt: "更新时间",
    type: "类型",
    uri: "URI"
  },
  action: {
    id: "ID",
    name: "名称",
    createdAt: "创建时间",
    code: "编码",
    description: "描述",
    menu: "关联菜单",
    updatedAt: "更新时间"
  },
  config: {
    id: "ID",
    name: "名称",
    createdAt: "创建时间",
    category: "类别",
    key: "键",
    value: "值",
    isPublic: "是否公开",
    updatedAt: "更新时间"
  },
  domain: {
    id: "ID",
    name: "名称",
    createdAt: "创建时间",
    syncedAt: "同步时间",
    updatedAt: "更新时间"
  },
  menu: {
    id: "ID",
    name: "名字",
    type: "类型",
    icon: "图标",
    path: "路径",
    route: "路由",
    level: "层级",
    parentId: "父ID",
    template: "关联模板",
    createdAt: "创建时间",
    syncedAt: "同步时间",
    updatedAt: "更新时间"
  },
  message: {
    createSuccess: "创建成功!",
    editSuccess: "编辑成功!",
    deleteSuccess: "删除成功!",
    returnSuccess: "还车成功!",
    pickSuccess: "取车成功!",
    ApproveSuccess: "审批成功"
  },
  role: {
    id: "ID",
    name: "名称",
    code: "编码",
    createdAt: "创建时间",
    updatedAt: "更新时间"
  },
  unit: {
    id: "ID",
    name: "名称",
    code: "编码",
    path: "路径",
    level: "层级",
    parentId: "父ID",
    createdAt: "创建时间",
    updatedAt: "更新时间"
  },
  // eslint-disable-next-line no-dupe-keys
  menu: {
    id: "ID",
    name: "名称",
    type: "类型",
    icon: "图标",
    path: "路径",
    route: "路由",
    level: "层级",
    parentId: "父ID",
    template: "关联模板",
    createdAt: "创建时间",
    updatedAt: "更新时间"
  },
  permission: {
    id: "ID",
    name: "名称",
    code: "编码",
    createdAt: "创建时间",
    updatedAt: "更新时间"
  },
  vehicle: {
    name: "车辆名称(EN)",
    nameL1: "车辆名称(CN)",
    carGroup: "车辆组",
    plateNumber: "车牌号",
    plateType: "车牌类型(EN)",
    plateTypeL1: "车牌类型(CN)",
    engine: "发动机(EN)",
    engineL1: "发动机(CN)",
    transmission: "变速箱(EN)",
    transmissionL1: "变速箱(CN)",
    seats: "座位数(EN)",
    seatsL1: "座位数(CN)",
    color: "车身颜色(EN)",
    colorL1: "车身颜色(CN)",
    capacity: "排量",
    plateDate: "上牌日期",
    img: "照片URL",
    fleet: "车队",
    vin: "车架号",
    initialMiles: "初始公里数",
    luggageCapacity: "后备箱容量",
    brand: "品牌",
    model: "型号",
    region: "取还车地区",
    site: "取还车服务点",
    initialDate: "始租日期",
    isEnabled: "是否在售",
    createdAt: "创建时间",
    updatedAt: "更新时间"
  },
  order: {
    orderNumber: "订单编号",
    carName: "订单名称",
    createdAt: "创建时间",
    updatedAt: "更新时间",
    startDate: "取车时间",
    updateDate: "更新时间",
    jobNumber: "员工工号",
    siteName: "取还车服务点",
    orderPrice: "订单价格",
    finalPrice: "支付价格",
    status: "状态",
    userPhone: "承租人电话",
    userName: "承租人姓名",
    driverLicenseNumber: "承租人驾驶证号",
    siteContact: "服务站点联系人",
    siteAddress: "服务站点地址",
    sitePhone: "电话",
    regionName: "区域名称",
    note: "取还车备注",
    fetchNote: "取车备注",
    returnNote: "还车备注",
    ApplyForApproval: "申请审批"
  },
  handover: {
    orderNumber: "订单编号",
    carName: "订单名称",
    createdAt: "创建时间",
    updatedAt: "更新时间",
    startDate: "待取车时间",
    endDate: "待还车时间",
    plateNumber: "车牌号",
    note: "备注",
    status: "状态",
    userName: "用户姓名",
    userPhone: "用户电话",
    driverLicenseNumber: "驾驶证号",
    startMiles: "取车公里数",
    endMiles: "还车公里数",
    fetchNote: "取车备注",
    returnNote: "还车备注"
  },
  goods: {
    title: "产品名称",
    carGroupId: "车辆组",
    validStartTime: "预订开始时间",
    validEndTime: "预订结束时间",
    type: "类型",
    imageUrl: "活动头图URL",
    desc: "活动描述图URL(EN)",
    descL1: "活动描述图URL(CN)",
    startDate: "活动开始时间",
    endDate: "活动结束时间",
    createdAt: "创建时间",
    subType: "子类型",
    year: "年份",
    region: "服务区域",
    price: "日价格",
    fleets: "车队",
    rentalCompany: "租赁公司",
    rule: "取消规则",
    punishDays: "提前取消时间(日)",
    punishDiscount: "手续费(%)",
    customerType: "客户组",
    updatedAt: "更新时间"
  },
  price: {
    title: "价格名称",
    employeePrice: "BMW员工价格",
    supplierPrice: "合作伙伴价格",
    dealerPrice: "经销商价格",
    createdAt: "创建时间",
    updatedAt: "更新时间"
  },
  region: {
    name: "区域名称(EN)",
    nameL1: "区域名称(CN)",
    id: "ID",
    isEnabled: "是否可用",
    createdAt: "创建时间",
    updatedAt: "更新时间"
  },
  feeAudit: {
    id: "Id",
    createAt: "申请时间",
    updatedAt: "更新时间",
    birthName: "员工姓名",
    jobNumber: "员工工号",
    department: "部门代码",
    birthCode: "出生证明编号",
    PickLocation: "领取地点",
    signature: "员工签名",
    Birth_photo: "出生证明照片",
    gender: "员工性别",
    mobile: "手机号",
    Entry: "入职日期",
    stateId: "状态",
    type: "类型",
    reason: "拒绝原因",
    price: "金额",
    updater: "审批人",
    pendingR: "待审核",
    pending: "待领取",
    Received: "已领取",
    rejected: "已拒绝",
    pass: "已通过",
    closed: "已关闭",
    Expired: "已超期",
    start: "开始",
    end: "结束",
    creater: "申请人",
    ascending: "升序",
    descending: "降序",
    email:'邮箱'
  },
  newlyMarried: {
    id: "Id",
    createAt: "申请时间",
    updatedAt: "更新时间",
    birthName: "员工姓名",
    jobNumber: "员工工号",
    department: "部门代码",
    newlyMarriedCode: "结婚证号",
    PickLocation: "领取地点",
    signature: "员工签名",
    newlyMarried_photo: "结婚证照片",
    gender: "员工性别",
    mobile: "手机号",
    Entry: "入职日期",
    stateId: "状态",
    type: "类型",
    reason: "拒绝原因",
    price: "金额",
    updater: "审批人",
    pendingR: "待审核",
    pending: "待领取",
    Received: "已领取",
    rejected: "已拒绝",
    pass: "已通过",
    closed: "已关闭",
    Expired: "已超期",
    start: "开始",
    end: "结束",
    creater: "申请人",
    ascending: "升序",
    descending: "降序",
    receiveType: "领取方式",
    bySelf: "自提",
    byMail: "邮寄"
  },
  "union":{
    name: "员工姓名",
    birthName: "员工姓名",
    jobNumber: "员工工号",
    department: "部门代码",
    approval: "审批日期",
    applyAt: "申请日期",
    createAt: "申请日期",
    hireDate: "入职日期",
    stateId: "状态",
    start: "开始",
    end: "结束",
    pending: "待确认",
    rejected: "被驳回",
    noPay: "待交费",
    paid: "已缴费",
    approved: "已审批",
    ascending: "升序",
    descending: "降序",
    uploadBtn: "批量导入审批结果",
    tip: "请输入拒绝原因",
    confirm: "确定",
    uploadError: "上传失败",
    uploadSuccess: "上传成功",
    dimission: "是否在职",
    onJob: "在职",
    noJob: "离职",
    personnelSubarea: "人员分区",
    fromBbaOther: "是否从宝马其他公司主体转入",
    yes: "是",
    no: "否",
    email: "邮箱"
  },
  "excelError":{
    "title": "下载提示",
    "okText": "继续导出报告",
    "tip": "根据BMW信息安全策略，此数据涉及敏感信息，请先完成审批、授权。",
    "checkboxText": "本人已完成审批，并获得操作该数据相关授权，本人严格遵守BMW信息安全策略",
    "error": "请选择需要下载的数据"
  },
  welfare: {
    id: "Id",
    name: "福利名称(CN)",
    name1: "福利名称",
    startAt: "开始时间",
    endAt: "结束时间",
    state: "状态",
    pending: "未开始",
    progress: "进行中",
    over: "已结束",
    toBeAvailable: "待上架",
    listM: "名单管理",
    enName: "福利名称(EN)",
    isOnSale: "是否上架",
    createAt: "申请时间",
    MessageName: "请填写福利名称(CN)!",
    MessageEnName: "请填写福利名称(EN)!",
    MessageStartAt: "请选择开始时间!",
    MessageEndAt: "请选择结束时间!",
    MessageDelete: "请选择需要删除的人员!",
    MessageAt: "选择的开始时间必须小于结束时间!",
    updatedAt: "更新时间",
    jobNumber: "员工工号",
    department: "部门代码",
    birthName: "员工姓名",
    signatureThumbnails: "签名",
    comment: "备注",
    pendingConfirm: "待确认",
    Confirmed: "已确认",
    expired: "已过期",
    unaccalimed: "未领取",
    exportUnclaimed: "导出未领取"
  },
  tableTemplate: {},
  ...zhLocale
};

export default cn;



// WEBPACK FOOTER //
// ./src/languages/zh-CN.js